/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroTemContrato.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroTemContrato() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-tem-contrato">
        <ContainerHome24>
          <div className="tem-contrato-textos">
            <h2 className="tem-contrato-titulo">Já tem um contrato de empréstimo com garantia?</h2>
            <p className="tem-contrato-texto">
              Se você já tem um contrato de empréstimo com garantia de veículo e quer saber sobre
              algum serviço, é só acessar a Área do Cliente para ver tudo sobre seu contrato.
            </p>
          </div>
          <RedButton
            href="https://emprestimosim.com.br/app/#/login/signInWithPassword?utm_source=portalSF&utm_medium=emprestimo-garantia-carro:area-do-cliente&utm_campaign=acessar"
            target="_blank"
            className="tem-contrato-btn"
          >
            Acessar Área do Cliente
          </RedButton>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && (
                <img
                  src="assets/emprestimo-garantia-carro/img-tem-contrato-desk.svg"
                  alt=""
                  className="tem-contrato-img"
                />
              )}
            </>
          )}
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width < 992 && (
              <img
                src="assets/emprestimo-garantia-carro/img-tem-contrato.svg"
                alt=""
                className="tem-contrato-img"
              />
            )}
          </>
        )}
      </section>

      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroTemContrato;
